import {combineReducers} from 'redux';
import inputField from './input-field';
import chatBody from './chat-body';
import chatRoot from './chat-root';
import chatHeader from './chat-header';

const app = combineReducers({
  inputField,
  chatBody,
  chatRoot,
  chatHeader
});

export default app;



// WEBPACK FOOTER //
// ./src/reducers/index.js